/* The one glyph in this set that is not sized by the control around it.
 *
 * `ChangeArrowIcon` stands INSIDE a line of text — a chart head's change, a reading tile's delta,
 * the comparison's change column — rather than inside a button, so it carries its own box. It was
 * declared identically in two stylesheets, and the two had already parted on `vertical-align`: a
 * pane's lines are `inline-flex`, where the property is inert, and the chart head's is not, where it
 * is the difference between an arrow on the baseline and one floating above it. So the complete rule
 * lives next to the component that draws it, and the component wears it itself. */

.arrow {
  flex: none;
  width: var(--sz-survey-arrow);
  height: var(--sz-survey-arrow);
  margin-inline-end: var(--space-3px);
  vertical-align: text-bottom;
}
